import type { FC } from 'react';

import { CombinatoricsToolSettings } from './combinatorics-tool-settings';
import { DecimalNumberToolSettings } from './decimal-number-tool-settings';
import { FunctionsToolSettings } from './functions-tool-settings';
import { NumberAndUnitsToolSettings } from './number-and-units-tool-settings';
import { NumericVariablesToolSettings } from './numeric-variables-tool-settings';
import { PropositionalLogicToolSettings } from './propositional-logic-tool-settings';
import { StringMatchToolSettings } from './string-match-tool-settings';
import { SymbolicEquivalenceToolSettings } from './symbolic-equivalence-tool-settings';
import { SymbolicNumberToolSettings } from './symbolic-number-tool-settings';
import { DEFAULT_SHORT_ANSWER_TOOL_LABEL, type ShortAnswerToolSettingsProps } from './tool-defaults';

export const SHORT_ANSWER_TOOL_SETTINGS_BY_LABEL: Record<string, FC<ShortAnswerToolSettingsProps>> = {
    [DEFAULT_SHORT_ANSWER_TOOL_LABEL]: StringMatchToolSettings,
    'Decimal number': DecimalNumberToolSettings,
    'Symbolic number': SymbolicNumberToolSettings,
    'Number and units': NumberAndUnitsToolSettings,
    'Numeric variables': NumericVariablesToolSettings,
    'Symbolic equivalence': SymbolicEquivalenceToolSettings,
    'Propositional logic': PropositionalLogicToolSettings,
    Combinatorics: CombinatoricsToolSettings,
    Functions: FunctionsToolSettings,
};
